<template>
    <div>
        <Status-bar></Status-bar>
        <div v-if="listData.length">
            <div class="container" >
                <p class="title">您正在预约e代驾{{companyName}}的路考，可预约最近1个月内空闲的时段。请选择：</p>
                <div class="list" v-for="(item, index) in listData" v-bind:key="item.inex">
                        <div class="item" @click="showItemDetail(index)" v-if="item.status==1&&showIndex!==index">
                            <span>{{item.date_desc}} {{item.hour_span}}</span> <span class="status">{{item.status_desc}}</span>
                        </div>
                        <div  v-if="item.status==2" class="no_click">
                            <span>{{item.date_desc}} {{item.hour_span}}</span> <span class="status">{{item.status_desc}}</span>
                        </div>
                        <div class="item_detail" v-if="showIndex==index">
                            <div class="icon"><img src="../../assets/choose.png"></div>
                            <div class="address_msg">
                                <p>{{item.date_desc}} {{item.hour_span}}</p>
                                <p>考点：{{item.name}}</p>
                                <p>地址：{{item.address}}</p>
                            </div>
                        </div>
                </div>
            </div>
            <!-- <div class="tips">预约未开放是说明当地的分公司目前没有招募安排,请您持续关注我们的预约平台，感谢您的理解！</div> -->
           <button @click="submit" :disabled="showIndex==-1" :style="{background:(showIndex==-1?'':bagColor)}">立即预约</button>
           <bottom-layout :phone="companyPhone"></bottom-layout>
        </div>
         <div v-else>
            <not-available ></not-available>
           <bottom-layout class="position" :phone="companyPhone"></bottom-layout>
         </div>
    </div>
</template>
<script>
import {showToast, changeHistory} from '../../utils/common'
import {roadbookingList, driverBooking} from '../../utils/actions'
import StatusBar from '@/components/StatusBar.vue'
import BottomLayout from './components/BottomLayout'
import NotAvailable from './components/NotAvailable'
export default {
  data () {
    return {
      listData: {},
      showIndex: -1,
      bagColor: 'linear-gradient(269deg, #3B414D 0%, #262A32 100%)',
      companyName: this.$store.state.companyName,
      companyPhone: this.$store.state.companyPhone
    }
  },
  components: {
    StatusBar,
    BottomLayout,
    NotAvailable
  },
  created () {
    this.roadbookingList()
    changeHistory()
  },
  methods: {
    showItemDetail (index) {
      this.showIndex = index
    },
    async roadbookingList () {
      let data = await roadbookingList({
        city_id: this.$store.state.cityId
      })
      if (data && data.data) {
        this.listData = data.data
      }
    },
    async submit () {
      let params = this.listData[this.showIndex]
      let obj = await driverBooking({
        id: this.$store.state.id,
        id_card: this.$store.state.idCar,
        city_id: params.city_id,
        district_id: params.district_id,
        date: params.date,
        hour: params.hour
      })
      if (obj.code == 1001) {//eslint-disable-line
        showToast(obj.message)
        setTimeout(() => {
          location.reload()
        }, 1000)
      } else if (obj.code == 0) {//eslint-disable-line
        this.$router.push({name: 'passStatus', params: {status: '14'}}) // 跳路考成功页面
      } else {
        showToast(obj.message)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
    height: 6.4rem;
    background: #f7f7f7;
    margin-top: .76rem;
    width: 86%;
    margin-left: 3%;
    padding:0 4%;
    font-size: .28rem;
    overflow: scroll;
    border-radius: .12rem;
    .title{
        margin: .56rem 0 .4rem 0;
    }
    .status{
        color: #4AA8EC;
        margin-left: .82rem;
        font-weight: bold;
    }
    .no_click{
        text-align: center;
        height: .82rem;
        line-height: .82rem;
        border-radius: .04rem;
        color:rgba(25, 25, 26, 0.3);
        background: #E9EBEF;
        .status{
        color:rgba(25, 25, 26, 0.3);
        }
    }
    .item{
        text-align: center;
        height: .82rem;
        line-height: .82rem;
        background: #fff;
        border: 1px solid #19191A;
        border-radius: .04rem;
    }
}
.item_detail{
    border: 1.5px solid #4AA8EC;
    border-radius: .04rem;
    background: #fff;
    margin: .3rem 0;
    width: 90%;
    padding:.28rem 5%;
    .icon{
         float: left;
         width: 10%;
        height: .5rem;
        line-height: .5rem;
        img{
        width: .26rem;
        height: .26rem;
        }
    }
    .address_msg{
        width: 90%;
        float: left;
    }
}
.item_detail:after{
    content: '';
    clear: both;
    display: block;
}
 .tips{
       font-size: .24rem;
        color: #97989B;
        width: 80%;
        text-align: center;
        margin: .36rem 0 .3rem 10%;
    }
    button{
        background: rgba(59, 65, 77, 0.3);;
        padding: 0;
        height: .92rem;
        line-height: .92rem;
        width: 84%;
        margin:.4rem 0 0 8%;
        color: #fff;
        border: none;
        border-radius: .04rem;
        font-size: .3rem;
        vertical-align: bottom;
    }
    .list{
      margin-bottom: .3rem;
    }
    .position{
        position: fixed;
        bottom: .4rem;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/appointed-road-test/index.vue